var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayBillFsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 54,
    viewBox: "0 0 80 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3204 0H7.6914C3.4531 0 0 3.4492 0 7.6914V13.3398H80V7.6914C80 3.4531 76.5587 0 72.3204 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.6528C0 49.8911 3.4492 53.3442 7.6914 53.3442H72.3124C76.5507 53.3442 79.9921 49.895 79.9921 45.6528V16.6328H0.000100136L0 45.6528ZM9.8594 31.2428C9.8594 29.692 11.1211 28.4342 12.6797 28.4342H20.2109C21.7695 28.4342 23.0195 29.6959 23.0195 31.2428V34.9147C23.0195 36.4733 21.7695 37.735 20.2109 37.735H12.6797C11.1211 37.735 9.8594 36.4733 9.8594 34.9147V31.2428Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayBillFsr);
export default __webpack_public_path__ + "static/media/PayBill-FSR.78d22208762d65d83c0b268f5b46481b.svg";
export { ForwardRef as ReactComponent };